import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  required,
  useGetList,
  useRecordContext,
} from 'react-admin';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Divider,
} from '@mui/material';
import {
  LocationOn as ZoneIcon,
  Factory as PlantIcon,
} from '@mui/icons-material';

const EditTitle = () => {
  const record = useRecordContext();
  return record ? `Editar Zona "${record.zoneName}"` : 'Editar Zona';
};

const ZonesEdit = () => {
  // Obtener lista de plantas
  const { data: plants, isLoading: plantsLoading } = useGetList('plants', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'plantName', order: 'ASC' },
  });

  return (
    <Edit title={<EditTitle />} redirect='show' mutationMode='pessimistic'>
      <Box sx={{ padding: 3, maxWidth: 800, margin: '0 auto' }}>
        <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
          <CardContent>
            <Box display='flex' alignItems='center' mb={3}>
              <ZoneIcon sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
              <Box>
                <Typography variant='h5' component='h1' fontWeight='bold'>
                  Editar Zona
                </Typography>
                <Typography variant='body2' color='text.secondary'>
                  Modifica la información de la zona
                </Typography>
              </Box>
            </Box>

            <SimpleForm
              sx={{
                '& .RaSimpleForm-toolbar': {
                  marginTop: 3,
                  padding: 2,
                  backgroundColor: 'background.paper',
                  borderRadius: 2,
                  boxShadow: 2,
                },
              }}
            >
              <Grid container spacing={3}>
                {/* Información Principal */}
                <Grid item xs={12} md={6}>
                  <Card
                    sx={{
                      height: 'fit-content',
                      boxShadow: 2,
                      borderRadius: 2,
                      backgroundColor: 'background.default',
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <ZoneIcon color='primary' />
                        <Typography variant='h6' fontWeight='bold'>
                          Información de la Zona
                        </Typography>
                      </Box>
                      <Divider sx={{ mb: 2 }} />

                      <TextInput
                        source='zoneName'
                        label='Nombre de la Zona'
                        validate={[required()]}
                        fullWidth
                        sx={{ mb: 2 }}
                        helperText='Nombre descriptivo para la zona'
                      />
                    </CardContent>
                  </Card>
                </Grid>

                {/* Planta Asociada */}
                <Grid item xs={12} md={6}>
                  <Card
                    sx={{
                      height: 'fit-content',
                      boxShadow: 2,
                      borderRadius: 2,
                      backgroundColor: 'background.default',
                    }}
                  >
                    <CardContent>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 2,
                        }}
                      >
                        <PlantIcon color='primary' />
                        <Typography variant='h6' fontWeight='bold'>
                          Planta Asociada
                        </Typography>
                      </Box>
                      <Divider sx={{ mb: 2 }} />

                      <ReferenceInput
                        source='plantId'
                        reference='plants'
                        sort={{ field: 'plantName', order: 'ASC' }}
                      >
                        <SelectInput
                          optionText='plantName'
                          optionValue='id'
                          label='Planta'
                          validate={[required()]}
                          fullWidth
                          isLoading={plantsLoading}
                          helperText='Selecciona la planta a la que pertenece esta zona'
                        />
                      </ReferenceInput>

                      <Box
                        sx={{
                          mt: 2,
                          p: 2,
                          backgroundColor: 'warning.light',
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant='body2' color='warning.dark'>
                          ⚠️ Cambiar la planta puede afectar las tablas y
                          variables existentes de la zona
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </SimpleForm>
          </CardContent>
        </Card>
      </Box>
    </Edit>
  );
};

export default ZonesEdit;
